/**
 * Ce fichier est chargé de remplir les formulaires en fonction des paramètres contenu dans l'url
 * Si le formulaire à un attribut data-url-params="off" alors il ne sera pas pré-remplit par les données
 * Si un input à un attribut data-url-params="off" alors il ne sera pas impacté par le remplissage
 */
import { PageParametre } from "../utils/FuncPageParametre";
import { setValue } from "../utils/Form";

/**N
 * Nom des formulaires pour lequel on ne gère pas les cookies (sauvegarde et restauration des valeurs)
 */
const ignoresForms = [
    'tjs_search_mobile',
    'tjs_search',
    'PAGE_RESULTAT',
    ''
]

/**
 * Tableau d'objet contenant les alias possible pour les champs de formulaire
 * Attention l'ordre des alias est important, mettre du plus strict au moins strict
 * @type {{TELEPHONE: [string]}[]}
 */
const aliasInputs = {
    telephone: ['tel'],
    nom: ['n'],
    prenom: ['pr'],
    besoin: ['b'],
    panier: ['pa'],
    societe: ['s'],
    numpop: ['np']
}

/**
 * Nom des inputs pour lesquelles on gère pas les paramètres
 * Attention : les clés ici doivent être en minuscule, les clés des inputs seront convertis en lowercase pour les cookies
 * @type {string[]}
 */
const ignoresInputs = [
    'g-recaptcha-response',
    'ville'
]

/**
 * Restaure les valeur des inputs en fonction des paramètres dans l'URL
 * @param HTMLElementForm Element HTML du formulaire
 */
const restoreFormDataWithURLParams = function(HTMLElementForm)
{
    const formData = new FormData(HTMLElementForm); //Récupération du formulaire en objet Javascript

    formData.forEach((value, key) => {

        const field = document.querySelector('[name="'+key+'"]')
        const activeParams = field.getAttribute('data-url-params') //Valeur de l'attribut data-page-params
        const aliasParams = field.getAttribute('data-url-params-alias') //Valeur de l'attribut data-page-params

        // console.log(activeParams)

        // Si on ignore le champ car le nom de l'input est dnas le tableau ignoresInputs
        // ou que l'attribut de l'input à un autocomplete="off"
        if(ignoresInputs.includes(key.toLowerCase())  || activeParams === 'off' || activeParams === false || activeParams === 'false')
        {
            // console.log("j'ignore la clé " + key)
            return false;
        }

        let URLParamValue; // Valeur du champ

        // On tente de récupérer la valeur en fonction du nom du champ ou d'un alias contenu dans un data-attribut
        const URLParamKey = (aliasParams) ? aliasParams.toLowerCase() : key.toLowerCase() // Alias via l'attribut data-url-params-alias
        URLParamValue = PageParametre(URLParamKey) // Valeur du paramètre

        // Si des alias existe pour le champ
        // On tente d'extraire une valeur d'un alias
        if(!URLParamValue && aliasInputs[key.toLowerCase()])
        {
            for (const alias in aliasInputs[key.toLowerCase()])
            {
                URLParamValue = PageParametre(aliasInputs[key.toLowerCase()][alias])
                if(URLParamValue) { break; }
            }
        }

        if(URLParamValue)
        {
            setValue(field, URLParamValue, key)
            return true;
        }

        return false;
    })
}

// Récupères les formulaires de la page
const forms = document.querySelectorAll('form')

// Pour chaque formulaire
forms.forEach(HTMLElementForm => {

    const formName = HTMLElementForm.getAttribute('name') //Nom du formulaire
    const activeParams = HTMLElementForm.getAttribute('data-url-params') //Valeur de l'attribut data-page-params

    // On ne gère pas les cookies pour le formulaire si :
    // Il n'a pas d'attribut name
    // Le nom du formulaire (attribut name) existe dans le tableau ignoreForms
    // Si le formulaire à un attribute data-cookie avec la valeur false ou no-cookie
    if(formName === null || (ignoresForms.includes(formName)) || activeParams === 'off' || activeParams === false || activeParams === 'false')
    {
        //console.log('pas de cookie pour le formulaire : ', formName)
        return false
    }

    restoreFormDataWithURLParams(HTMLElementForm)
})

